<template>
  <v-layout
    row
    wrap
    fill-height
  >
    <v-card
      class="mx-auto align-self-center"
      color="white"
      elevation-1
      hover
      width="400"
    >
      <v-card-title>
        <h2 class="primary--text font-weight-regular mx-auto">
          ¿ Confirma la anulacion del turno ?
        </h2>
      </v-card-title>
      <div class="text-xs-right mt-4">
        <v-btn
          class="error"
          :disabled="loading"
          :loading="loading"
          @click="cancelAppointment"
        >
          Anular
        </v-btn>
        <v-btn
          class="primary"
          :disabled="loading"
          @click="cancelar"
        >
          Cancelar
        </v-btn>
      </div>
    </v-card>
  </v-layout>
</template>

<script>
import { anularTurno } from '../api/appointmentsEndpoints'

export default {
  name: 'AppointmentCancelView',
  data () {
    return {
      loading: false,
      menu: false
    }
  },
  methods: {
    async cancelAppointment () {
      const prepareObject = {
        pacienteId: this.$route.query.pacienteid,
        turno: this.$route.query.turno
      }
      this.loading = true
      const removeAppointment = await anularTurno(prepareObject)
      this.cancelar()
      this.loading = false
      if (removeAppointment.respuesta === 'ERROR') {
        this.$createAlert({
          message: removeAppointment.mensaje,
          type: 'error',
          duration: 5000
        })
      } else {
        this.$createAlert({
          message: 'Turno Anulado',
          type: 'success',
          duration: 3000
        })
      }
      this.$router.push('/seleccion')
    },
    cancelar () {
      this.$router.push('/seleccion')
    }
  }
}
</script>

<style scoped lang="sass">
  .progress-circle
    margin: 40vh auto
</style>
